import {
	PaddedContainer,
	SPACING,
	SquareImgTile,
	Text,
} from "@disco/disco_core";
import React from "react";
import "./engage-secondary-tile.css";
import getImgUrl from "../../utils/getImgUrl";
import Color from "color-thief-react";

const isColorDark = (bgColor) => {
	const [r, b, g] = bgColor;
	return r * 0.299 + g * 0.587 + b * 0.114 <= 186;
};

const EngageSecondaryTileContent = ({
	data,
	heading,
	subheading,
	children,
	fullGradient = false,
}) => {
	const hasError = !data;
	const rawBgColor = !data ? [255, 255, 255] : data;
	const bgColor = fullGradient ? [255, 255, 255] : rawBgColor;
	const rawBgColorString = rawBgColor.join(", ");
	const bgColorString = bgColor.join(", ");

	const initialBgColorOpacity = fullGradient ? 0.75 : 0.9;

	const isRawBgDark = isColorDark(rawBgColor);
	const isBgDark = isColorDark(bgColor);

	let derivedForegroundColor = isBgDark ? "#FFFFFF" : "#000000";

	const contentClassName = `engage-secondary-tile-content${
		fullGradient ? " full-gradient" : ""
	}`;

	return (
		<PaddedContainer className={contentClassName}>
			<PaddedContainer
				className="engage-secondary-tile-content-background"
				style={{
					background: fullGradient
						? `linear-gradient(to top, rgba(${bgColorString}, ${initialBgColorOpacity}) 100%, rgba(${bgColorString}, ${initialBgColorOpacity}))`
						: `linear-gradient(to top, rgba(${bgColorString}, ${initialBgColorOpacity}) 50%, rgba(${bgColorString}, 0))`,
				}}
			/>
			<Text
				className="engage-secondary-tile-content-foreground"
				hPadding={SPACING.TINY}
				style={{ color: derivedForegroundColor }}
			>
				{typeof children === "function"
					? children({
							rawBgColor,
							bgColor,
							rawBgColorString,
							bgColorString,
							derivedForegroundColor,
							isRawBgDark,
							isBgDark,
					  })
					: children}
				{subheading && (
					<Text
						style={{
							lineHeight: "16px",
							height: "32px",
							overflow: "hidden",
							display: "flex",
							flexDirection: "column",
							justifyContent: "flex-end",
						}}
						size={"label"}
					>
						{subheading}
					</Text>
				)}
				<Text thick size={"body"} marginTop={SPACING.MICRO} ellipsis>
					<b>{heading}</b>
					{fullGradient && (
						<PaddedContainer
							style={{
								background: `rgba(${
									hasError ? "0, 0, 0" : rawBgColorString
								}, 0.4)`,
							}}
							className="engage-secondary-tile-content-full-gradient-heading-underline"
						/>
					)}
				</Text>
			</Text>
		</PaddedContainer>
	);
};

const EngageSecondaryTile = ({
	product,
	brand,
	subheading,
	fullGradient,
	children,
}) => {
	const imgUrl = getImgUrl(product);

	const { name: brandName = "" } = brand || {};

	return (
		<PaddedContainer className="engage-secondary-tile" clickable>
			<img src={imgUrl} alt="" />
			{!fullGradient && (
				<SquareImgTile
					className="engage-secondary-tile-brand-logo"
					src={getImgUrl(brand, 150, 150, "logo_url")}
					width={"32px"}
					circular
				/>
			)}
			<Color src={imgUrl} format="rgbArray" crossOrigin="Anonymous">
				{({ data }) => (
					<EngageSecondaryTileContent
						data={data}
						heading={brandName}
						subheading={subheading}
						fullGradient={fullGradient}
					>
						{children}
					</EngageSecondaryTileContent>
				)}
			</Color>
		</PaddedContainer>
	);
};

export default EngageSecondaryTile;
